var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 15.9954,
    viewBox: "0 0 16 15.9954",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.57628e-07 15.9954C3.57628e-07 7.16154 7.16352 0.000111103 16 0.000111103L16 15.9954L3.57628e-07 15.9954Z",
    fill: "#D4623A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 3.99883C0 1.79029 1.79087 0 4 0C6.20913 0 8 1.79029 8 3.99883C8 6.20737 6.20913 7.99767 4 7.99767C1.79087 7.99767 0 6.20737 0 3.99883Z",
    fill: "#508FCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif18);
export default __webpack_public_path__ + "static/media/motif-18.e348f5787babf7eb05bbd1e94c273544.svg";
export { ForwardRef as ReactComponent };